import React from 'react';
import Grid from "@mui/material/Grid";
import PersonalDetails from "./PersonalDetails";
import Education from "./Education";
import Experience from "./Experience";
import AdditionalQuestions from "./AdditionalQuestions";
import Skills from "./Skills";
import Paper from "@mui/material/Paper";

export default function ApplicationDetails({cv, updateCV, jobPlacement, workModel}) {

    return (
                <Grid container direction={"row"} spacing={2} padding={2} data-testid={"applicationDetails"}>
                    <Grid item xs={12}>
                        <h3>Application Summary</h3>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper padding={2} elevation={0} style={{pointerEvents: "none"}}>
                            <PersonalDetails personalDetails={cv.personalDetails} updateCV={updateCV} readOnly={true}/>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper padding={2} elevation={0} style={{pointerEvents: "none"}}>
                        <Education education={cv.education} updateCV={updateCV} readOnly={true}/>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper padding={2} elevation={0} style={{pointerEvents: "none"}}>
                        <Experience experience={cv.experience} updateCV={updateCV} readOnly={true}/>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper padding={2} elevation={0} style={{pointerEvents: "none"}}>
                        <Skills skills={cv.skills} updateCV={updateCV} readOnly={true}/>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper padding={2} elevation={0} style={{pointerEvents: "none"}}>
                        <AdditionalQuestions additionalQuestions={cv.additionalQuestions} updateCV={updateCV} readOnly={true} jobPlacement={jobPlacement} workModel={workModel}/>
                        </Paper>
                    </Grid>
                </Grid>
    )
}